// OperationBenefitsAddEditModal.js
import React, { useState, useEffect, useMemo } from "react";
import CloseIcon from "@mui/icons-material/Close";
import LockIcon from '@mui/icons-material/Lock';
import { Input } from "../../../../../common/Input";
import { Select } from "../../../../../common/Select";

const OperationBenefitsAddEditModal = ({ 
  isOpen, 
  onClose, 
  selectedItem,
  groupOptions,
  loading,
  onSave, 
  mode = "Add", 
  rules = []
}) => {

  // MODIFIED: Convert rules into selectable options for the dropdown
  const rateCategoryOptions = useMemo(() => {
    return rules.map(r => ({
      value: r.id,
      label: r.category || `Rule ID: ${r.id}`
    }));
  }, [rules]);

  const [errors, setErrors] = useState({});
  const [form, setForm] = useState({
    rate: 0,
    operationBenefitGroupId: "",
    maintenanceSalaryCombinationV2Id: "" // MODIFIED: Link to specific Rate Rule
  });

  useEffect(() => {
    if (isOpen) {
      if (selectedItem) {
        setForm(selectedItem);
      } else {
        setForm({
          rate: 0,
          operationBenefitGroupId: "",
          maintenanceSalaryCombinationV2Id: ""
        });
      }
      setErrors({});
    }
  }, [isOpen, selectedItem]);

  const validate = () => {
    const e = {};
    if (!form.operationBenefitGroupId) e.group = "Benefit Group is required";
    if (!form.maintenanceSalaryCombinationV2Id) e.rateHeader = "Target Rate Category is required"; // ADDED
    if (form.rate === null || form.rate === undefined || form.rate === "") e.rate = "Rate is required";
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleSave = () => {
    if (validate()) onSave(form);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[10000] bg-black/50 flex items-center justify-center p-4">
      <div className="bg-white w-full max-w-md rounded-xl shadow-2xl flex flex-col overflow-hidden">
        <div className="px-6 py-4 border-b flex justify-between items-center bg-gray-50">
          <h2 className="text-lg font-bold text-gray-800">{mode} Operation Benefit</h2>
          <CloseIcon className="cursor-pointer text-gray-400 hover:text-red-500" onClick={onClose} />
        </div>

        <div className="p-6 space-y-5">
          <div className="bg-blue-50 border border-blue-100 rounded-lg p-3 flex items-center gap-2">
            <LockIcon className="text-blue-400" fontSize="small" />
            <span className="text-[10px] font-bold text-blue-700 uppercase tracking-widest">Locked to Selected Filters</span>
          </div>

          {/* ADDED: Link to specific Rate Category */}
          <Select
            label="Apply to Rate Category"
            placeholder="-- Select Rate --"
            options={rateCategoryOptions}
            value={form.maintenanceSalaryCombinationV2Id}
            onChange={(e) => setForm({ ...form, maintenanceSalaryCombinationV2Id: e.target.value })}
            error={!!errors.rateHeader}
            errorMessage={errors.rateHeader}
          />

          <Select
            label="Benefit Group"
            placeholder={loading ? "Loading..." : "-- Select Group --"}
            options={groupOptions}
            value={form.operationBenefitGroupId}
            onChange={(e) => setForm({ ...form, operationBenefitGroupId: e.target.value })}
            error={!!errors.group}
            errorMessage={errors.group}
            disabled={loading}
          />

          <Input
            label="Rate Value"
            type="number"
            placeholder="0.00"
            value={form.rate}
            onChange={(e) => setForm({ ...form, rate: e.target.value })}
            error={!!errors.rate}
            errorMessage={errors.rate}
          />
        </div>

        <div className="p-4 border-t flex justify-end gap-2 bg-gray-50 rounded-b-xl">
          <button onClick={onClose} className="px-4 py-2 border rounded bg-white font-bold text-gray-500 cursor-pointer">CANCEL</button>
          <button onClick={handleSave} className="px-8 py-2 bg-blue-600 text-white rounded border-none font-bold cursor-pointer">SAVE BENEFIT</button>
        </div>
      </div>
    </div>
  );
};

export default OperationBenefitsAddEditModal;